const assetTypes = [
  {
    value: 'cash',
    label: 'Cash',
    subtypes: [
      { value: 'checking_account', label: 'Checking Account' },
      { value: 'savings_account', label: 'Savings Account' },
      { value: 'money_market_account', label: 'Money Market Account' },
    ],
  },
  {
    value: 'investment',
    label: 'Investment',
    subtypes: [
      { value: 'brokerage', label: 'Brokerage' },
      { value: 'retirement_account', label: 'Retirement Account' },
    ],
  },
  {
    value: 'real_estate',
    label: 'Real Estate',
    subtypes: [
      { value: 'real_estate', label: 'Home' },
      { value: 'investment_property', label: 'Investment Property' },
      { value: 'land', label: 'Land' },
    ],
  },
  {
    value: 'private_asset',
    label: 'Private Asset',
    subtypes: [
      { value: 'collectibles', label: 'Collectibles' },
      { value: 'precious_metals', label: 'Precious Metals' },
      { value: 'business_ownership', label: 'Business Ownership' },
      { value: 'banking', label: 'Banking' },
    ],
  },
];

export default assetTypes;
